(function () {
    'use strict';

    angular.module('settings')
        .controller('FaqUpdateController', FaqUpdateController);

    FaqUpdateController.$inject = ['$state', 'faqDataSrvc', 'notificationSrvc', 'faqMessagesConst', 'faqSectionsConst', 'errorNotificationSrvc'];

    function FaqUpdateController($state, faqDataSrvc, notificationSrvc, faqMessagesConst, faqSectionsConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            title_pl: [],
            description_pl: [],
            title_en: [],
            description_en: [],
            title_de: [],
            description_de: [],
            title_cpde: [],
            description_cpde: [],
            title_cpen: [],
            description_cpen: [],
            section: [],
            nonFieldErrors: []
        };
        self.faqData = {};

        self.sections = faqSectionsConst;

        self.updateFaq = updateFaq;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getFaq();
        }

        function getFaq() {
            return faqDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                self.faqData = response;

                delete self.faqData.date_modified;
                delete self.faqData.date_added;
                return response;
            });
        }

        function updateFaq() {
            faqDataSrvc.update({
                pk: self.faqData.pk
            }, self.faqData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", faqMessagesConst.update);
                    $state.go('layout.faq.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
